import { createSelector } from '@ngrx/store'
import { AppState } from '../storage'
import { LumpSumState } from './lump-sum.state'

export const selectLumpSum = (state: AppState) => state.lumpSum

export const selectLumpSumExportProgress = createSelector(selectLumpSum, (state: LumpSumState) => state.exportProgress)

// wp
export const select_LS_WPList = createSelector(selectLumpSum, (state: LumpSumState) => state.workpackageList)

export const select_isLoading_LS_WPList = createSelector(selectLumpSum, (state: LumpSumState) => state.isLoadingWorkpackageList)

// summary for wp
export const select_LS_SummaryForWp_Data = createSelector(selectLumpSum, (state: LumpSumState) => state.summaryForWp?.summaryForWpData)

export const select_isLoading_LS_SummaryForWp_Data = createSelector(selectLumpSum, (state: LumpSumState) => state.summaryForWp?.isLoadingSummaryForWpData)

// costs per wp
export const select_LS_BeneficiariesList = createSelector(selectLumpSum, (state: LumpSumState) => state.beneficiariesList)

export const select_isLoading_LS_BeneficiariesList = createSelector(selectLumpSum, (state: LumpSumState) => state.isLoadingBeneficiariesList)

export const select_LS_CostsPerWp_BeneficiarySummaryTableData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.costPerWp?.beneficiarySummaryTableData
)

export const select_isLoading_LS_CostsPerWp_BeneficiarySummaryTableData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.costPerWp?.isLoadingBeneficiarySummaryTableData
)

export const select_LS_CostsPerWp_SingleWpTableData = createSelector(selectLumpSum, (state: LumpSumState) => state.costPerWp?.singleWpTableData)

export const select_isLoading_LS_CostsPerWp_SingleWpTableData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.costPerWp?.isLoadingSingleWpTableData
)

export const select_isLoading_LS_CostsPerWp_UpdateSingleWpTableData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.costPerWp?.isLoadingUpdateSingleWpTableData
)

// estimated breakdown
export const select_LS_EstimatedBreakdownData = createSelector(selectLumpSum, (state: LumpSumState) => state.estimatedBreakdown?.estimatedBreakdownData)

export const select_isLoading_LS_EstimatedBreakdownData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.estimatedBreakdown?.isLoadingEstimatedBreakdownData
)

// person months
export const select_LS_PersonMonthsData = createSelector(selectLumpSum, (state: LumpSumState) => state.personMonths?.personMonthsData)

export const select_isLoading_LS_PersonMonthsData = createSelector(selectLumpSum, (state: LumpSumState) => state.personMonths?.isLoadingPersonMonthsData)

// depreciation
export const select_LS_DepreciationData = createSelector(selectLumpSum, (state: LumpSumState) => state.depreciation?.depreciationData)

export const select_isLoading_LS_DepreciationData = createSelector(selectLumpSum, (state: LumpSumState) => state.depreciation?.isLoadingDepreciationData)

export const select_isLoading_LS_DepreciationData_Update = createSelector(selectLumpSum, (state: LumpSumState) => state.depreciation?.isLoadingDepreciationData)

// resource types
export const select_LS_ResourceTypes = createSelector(selectLumpSum, (state: LumpSumState) => state.resourceTypes)

// any comments
export const select_LS_AnyCommentsData = createSelector(selectLumpSum, (state: LumpSumState) => state.anyComments?.anyCommentsData)

export const select_isLoading_LS_AnyCommentsData = createSelector(selectLumpSum, (state: LumpSumState) => state.anyComments?.isLoadingAnyCommentsData)

export const select_isLoading_LS_UpdateAnyCommentsData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.anyComments?.isLoadingUpdateAnyCommentsData
)

// change log
export const select_LS_ChangeHistoryData = createSelector(selectLumpSum, (state: LumpSumState) => state.changeHistory?.changeHistoryData)

export const select_isLoading_LS_ChangeHistoryData = createSelector(selectLumpSum, (state: LumpSumState) => state.changeHistory?.isLoadingChangeHistoryData)

export const select_isLoading_LS_UpdateChangeHistoryData = createSelector(
   selectLumpSum,
   (state: LumpSumState) => state.changeHistory?.isLoadingUpdateHistoryLogData
)
